import React, { useEffect, useState, useRef } from "react";
// import Link from "next/link";
// import Image from "next/image";
// import ProductListingDetails from "../ProductListingDetails";
import QuickBuyComp from "@/components/QuickBuyComp";
import Srcset from "@/components/common/Srcset";
import { useDispatch, useSelector } from "react-redux";
import { imgURL, makeId, srcsetMaker } from "@/helpers/userHelpers";
import { Klaviyo_viewed_product, Klaviyo_wishlist, Klaviyo_wishlist_remove } from "@/components/common/Klaviyo";
import { PRODUCT_MEDIA_QUERY } from "gql/productMedia";
import apolloClient from "gql/apolloClient";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import styles from "@/components/BundleComp/bundleComp.module.scss";

import {
  selectPLPVariant,
} from "@/helpers/pdpHelpers/pdpVariantHelpers";
import { getVariantFinalOptions } from "@/helpers/plpHelper";
import { generateBadge } from "@/helpers/pdpHelpers/badgeHelpers";
import { getVariantPrice } from "@/helpers/pdpHelpers/priceHelpers";

const BundleProductTile = (props) => {
  const [product_select, setProduct_select] = useState();
  const [firstVariant, setFirstVariant] = useState();
  const [clicked, setClicked] = useState(false);
  const [hideQuickBuy, setHideQuickBuy] = useState(false);
  const [showQuickBuyOption, setShowQuickBuyOption] = useState(false);
  const [generateQuickBuy, setGenerateQuickBuy] = useState(false);
  const [finalProductPrice, setFinalProductPrice] = useState();
  const [cancelledProductPrice, setCancelledProductPrice] = useState();
  let logUser = useSelector((state) => state.loginUser);
  const { shouldAddRandomId } = props;
  let randomId = null;
  if(shouldAddRandomId) {
    randomId = makeId(3);
  }

  function add3Dots(string, limit) {
    var dots = "...";
    if (string.length > limit) {
      // you can also use substr instead of substring
      string = string.substring(0, limit) + dots;
    }

    return string;
  }

  const [badgeCurated, setBadgeCurated] = useState('');
  let product = null;
  let wishlistFeatureEnabled = true;
  let impactMessageEnabled = true;
  const isOnlyMobile = useMediaQuery("(max-width: 767px)");
  useEffect(()=>{
    if(props.isCarousel) {
      setHideQuickBuy(true);
    }
  },[props.isCarousel]);

  product = props.product;

  const generateBadgeData = async (productTags) => {
    let badge = await generateBadge(productTags.reverse());
    setBadgeCurated(badge);
  };
  useEffect(()=>{
    generateBadgeData(product.tags.reverse());
  },[product.tags]);

  if (typeof props.wishlistFeatureEnabled != "undefined") {
    wishlistFeatureEnabled = props.wishlistFeatureEnabled;
  }
  if (typeof props.impactMessageEnabled != "undefined") {
    impactMessageEnabled = props.impactMessageEnabled;
  }
  let lazyLoad = false;
  if (props.isMobile && props.itemkey > 2) {
    lazyLoad = true;
  } else if (props.itemkey > 4) {
    lazyLoad = true;
    
  }

  const [variantsFinalOptions,setVariantsFinalOptions]=useState({});
  const [quickBuyClicked,setQuickBuyClicked]=useState(false);
  const [productDetails,setProductDetails]=useState();
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedLetter, setSelectedLetter] = useState(null);


  useEffect(()=>{
    setProductDetails(product);
    let ret = getVariantFinalOptions(product.variants.edges,product.options,product.tags,product.handle)
    setFirstVariant(product.variants?.edges[0]?.node)
    setVariantsFinalOptions(ret);
    setSelectedSize(ret.sizes && ret.sizes.length==1 ? ret.sizes.find(el => el !== undefined) : null);
    if(product.tags.includes("personalized")) {
      setSelectedLetter(ret.letters && ret.letters.length==1 ? ret.letters.find(el => el !== undefined) : null);
      setSelectedColor(null);
    } else {
      setSelectedColor(ret.colors && ret.colors.length==1 ? ret.colors.find(el => el !== undefined) : null);
      setSelectedLetter(null)
    }
    setShowQuickBuyOption(true)
  },[product.handle,generateQuickBuy]); 

  useEffect(()=>{
    productDetails?.tags?.map((element) => {
      if (element.split(":").shift() === "categories.lvl0") {
        productDetails.named_tags = {
          category: element?.split(":").pop(),
        };
      }
    });

    if(productDetails) {
      productDetails.productType =productDetails?.product_type?.value
      ? productDetails.product_type.value
      : "regular";
    }
  },[productDetails]);

  const selectedVariant = selectPLPVariant(
    null,
    variantsFinalOptions.variantMap,
    selectedColor,
    selectedSize,
    selectedLetter,
    variantsFinalOptions.sizes ? variantsFinalOptions.sizes.length : 0,
    setSelectedSize,
    product.id
  );


  useEffect(()=>{
    let price,
      salePrice;
      let productType = product?.product_type?.value
      ? product.product_type.value
      : "regular";
      let priceObj = selectedVariant ? getVariantPrice(selectedVariant, productType) : getVariantPrice(firstVariant, productType);
      if (priceObj.returnedPrice) {
        price = priceObj.returnedPrice;
      }
      if (priceObj.returnedSalePrice) {
        salePrice = priceObj.returnedSalePrice;
      }
      let finalProductPrice = salePrice ? salePrice : price;
      setFinalProductPrice(finalProductPrice)
      setCancelledProductPrice(salePrice ? price : null)
  },[firstVariant,selectedVariant])

useEffect(()=>{
  Klaviyo_viewed_product(product_select,logUser?.UserData?.email, process.env.NETLIFY_URL)
},[product_select])
  return (
    <>
      <a
        href={`${process.env.NETLIFY_URL}/products/${product.handle}`}
        onClick={() => {
          props.autocomplete?.refresh();
        }}
        /* ga-product-bundle-tile, this class is for GA. Do not change or remove. */
        className='ga-product-bundle-tile'
        tabIndex={-1}
      >
        <div tabindex={0} className={`${styles.product_tile}`} onClick={() => {
            setProduct_select(product);
            setClicked(true);
          }}>
          {product.featuredImage && <div className={styles.product_image}>
            <Srcset src={product.featuredImage.src} />
          </div>}
          <div className={styles.product_details}>
            <div className={`${styles.designer_name} normal-md x-small-sm x-small-xs medium`}>{product.vendor}</div>
            <div className={`${styles.description} x-small-md xx-small-sm xx-small-xs`}>{add3Dots(
              product.title
                .split("<br>")[0]
                .replace("<p>", ""),
              67
            )}</div>
            <div className={`${styles.price} x-small-md x-small-sm xx-small-xs medium`}>{finalProductPrice}</div>
            {variantsFinalOptions.showQuickBuy &&
              < QuickBuyComp qb_array={variantsFinalOptions}
                selectedColor={selectedColor}
                setSelectedColor={setSelectedColor}
                selectedLetter={selectedLetter}
                setSelectedLetter={setSelectedLetter}
                selectedSize={selectedSize}
                setSelectedSize={setSelectedSize}
                selectedVariant={selectedVariant}
                handle={product.id}
                quickBuyClicked={quickBuyClicked}
                setQuickBuyClicked={setQuickBuyClicked}
                badge_curated={badgeCurated}
                link={`${process.env.NETLIFY_URL}/products/${product.handle}`}
                productDetails={productDetails}
                isOnlyMobile={isOnlyMobile}
                productImage={product.product_image}
                searchComp={props.searchComp}
                generateQuickBuy={generateQuickBuy}
                setGenerateQuickBuy={setGenerateQuickBuy}
                product_handle={product.handle}
                pdp_view={true}
                bundleQuickBuy={true} // To enable GA events only for bundle comp
              />
            }
          </div>
        </div>
      </a>
    </>
  );
};

export default BundleProductTile;
